import React from 'react';

export const LeaderboardPage: React.FC = () => {
  return (
    <div className="text-center py-16">
      <h1 className="text-2xl font-bold text-foreground mb-2">
        Leaderboard
      </h1>
      <p className="text-muted-foreground">
        Leaderboard will be implemented here
      </p>
    </div>
  );
};